import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {IMessage} from '@stomp/stompjs';

import {getScheduleTrackerRequestsCount, updateScheduleTrackerRequestsCount} from '@/redux/commonScheduleTracker/slice';
import websocketService from '@/services/webSocketService';
import {ScheduleTrackerRequestsCountDTO} from '@/types/gatewayDataModels';

export const useScheduleTrackerRequestsCounter = (nurseId: number) => {
    const dispatch = useDispatch();
    const wsEndpoint = `/topic/schedule-tracker-counter/${nurseId}`;

    useEffect(() => {
        dispatch(getScheduleTrackerRequestsCount());

        if (wsEndpoint) {
            websocketService.subscribe(wsEndpoint, (message: IMessage) => {
                const data: ScheduleTrackerRequestsCountDTO = message?.body
                    ? (JSON.parse(message?.body) as ScheduleTrackerRequestsCountDTO)
                    : null;
                dispatch(updateScheduleTrackerRequestsCount(data?.count || 0));
            });
            return () => {
                websocketService.unsubscribe(wsEndpoint);
            };
        }
    }, [dispatch, wsEndpoint]);
};
